import { useField, useFormikContext } from 'formik'
import { useFilters } from 'map-filter-view'
import { ApplyFiltersInput as Input } from 'ui-components'

const ApplyFiltersInput = () => {
  const filters = useFilters()
  const hasFilters = filters.length > 0

  const form = useFormikContext()
  const [field] = useField({
    name: 'filters',
    defaultChecked: hasFilters
  })

  return (
    <Input
      name='filters'
      disabled={form.isSubmitting}
      checked={field.value}
      onChange={field.onChange}
    />
  )
}

export { ApplyFiltersInput }
